export default __webpack_public_path__ + "static/media/no_course_logo.85f6081d.png";